import { Component, OnInit, HostListener } from '@angular/core';
import { Scroll } from '@angular/router';

import { knowledgeGraph, searchItem, database, tools} from '../carousel'

@Component({
  selector: 'app-main-page',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.css']
})
export class MainPageComponent implements OnInit {

  knowledgeGraph = knowledgeGraph;
  searchItem = searchItem;
  database = database;
  tools = tools;


  private pageArry = ['welcome', 'knowledge_graph', 'search', 'database', 'tools'];
  private index = 0;
  array = [1, 2, 3, 4];


  constructor() { }

  ngOnInit() {
  }

  
   /* 
  @HostListener('mousewheel',['$event'])
  mouseDelta(e){
      let target = document.getElementById('welcome');
      let positionY = 0;
      if(e.deltaY > 0 && this.index != 4){
        this.index += 1;
        target = document.getElementById(this.pageArry[this.index]);
        scrollTo(0, target.offsetTop)
      }
      else if(e.deltaY < 0 && this.index != 0){
        this.index -= 1;
        //target = document.getElementById(this.pageArry[this.index]);
      }
  }
  */


}
